import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import chunkToTimeString from './chunkToTimeString.filter';
import './dashboard/changelog.html';
import ecDateFormat from './dateFormat.directive';
import durationFilter from './duration.filter';
import toTrustedHtml from './html.filter';
import humanizeDurationService from './humanizeDuration.service';

import momentFilter from './moment.filter';
import notificationHelper from './notification.helper';
// Import html templates
import './partials/header.html';
import './partials/header/subnav.html';
import './partials/nav.html';
import removeAccents from './removeAccents.filter';
import chunksService from './services/chunks.service';
import countryService from './services/country.service';
import DestinationService from './services/destination.service';
import domainService from './services/domain.service';
import switchToBAService from './services/switchToBA.service';
import switchToBcService from './services/switchToBc.service';
import switchToRMAService from './services/switchToRMA.service';
import switchToHostService from './services/switchToHost.service';
import sessionServiceDecorator from './sessionService.decorator';
import SigninController from './signin/signin.controller';
import { InputWithCounterComponent } from '../shared/components/input-with-counter/input-with-counter.component';
import switchToQRBService from 'OpsCenter/common/services/switchToQRB.service';
import externalSourcesService from 'OpsCenter/common/services/externalSources.service';

/** @constant {angular.module} */
const commonsModule = angular
  .module('ec.opsCenter.common', [])
  .factory('humanizeDurationService', humanizeDurationService)
  .factory('notificationHelper', notificationHelper)
  .filter('moment', momentFilter)
  .filter('duration', durationFilter)
  .filter('removeAccents', removeAccents)
  .filter('chunkToTimeString', chunkToTimeString)
  .filter('toTrustedHtml', toTrustedHtml)
  .directive('ecDateFormat', ecDateFormat)
  .directive('inputWithCounter', downgradeComponent({ component: InputWithCounterComponent}) as angular.IDirectiveFactory)
  .service('DestinationService', DestinationService)
  .service('switchToBcService', switchToBcService)
  .service('switchToBAService', switchToBAService)
  .service('switchToRMAService', switchToRMAService)
  .service('switchToHostService', switchToHostService)
  .service('switchToQRBService', switchToQRBService)
  .service('countryService', countryService)
  .service('chunksService', chunksService)
  .service('domainService', domainService)
  .service('externalSourcesService', externalSourcesService)
  .decorator('sessionService', sessionServiceDecorator)
  .controller('SigninController', SigninController).name;

export default commonsModule;



// WEBPACK FOOTER //
// ./src/app/common/common.module.ajs.ts